export const FINAL_FOOTAGE_LENGTH_SECONDS = 300;
export const FINAL_FOOTAGE_MAX_FILE_SIZE_MB = 2 * 1024;
export const PREMIUM_AVATAR_CREATION_COST_MINUTES = 10;
